import PropTypes from 'prop-types'
import { Stack, Text } from '@leroy-merlin-br/backyard-react-ui'

import { Icon } from 'lmcv/components/Icon'
import { STATUS_DATA } from 'lmcv/pages/Customers/constants/statusData'

import * as S from './styled'

const TimelineItem = ({ icon, children, status }) => {
  const currentColor = STATUS_DATA[status].color

  return (
    <S.Container status={status} color={currentColor}>
      <Stack spacing="giga">
        <S.Circle>
          <Icon
            name={icon || STATUS_DATA[status].icon}
            width={27}
            height={27}
            fill={currentColor}
          />
        </S.Circle>
        <Text size="kilo">{children}</Text>
      </Stack>
    </S.Container>
  )
}

TimelineItem.propTypes = {
  status: PropTypes.string,
  icon: PropTypes.string,
  children: PropTypes.node
}

export default TimelineItem
